import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useEmployee = (id) => useQuery({ queryKey: [`employee-${id}`], queryFn: async () => {
    if(!id) return null
    const callback = await API.get(`/employees/${id}`)
    return callback?.data
}, staleTime: 1000 * 60 * 60, gcTime: 1000 * 60 * 60 * 24})

export default useEmployee